import { createSelector } from "@reduxjs/toolkit";
export const selectAddressesFetchState = createSelector((state) => state.checkout.addresses.fetchStatus, (fetchStatus) => {
    return {
        status: fetchStatus,
        isIdle: fetchStatus === "idle",
        isLoading: fetchStatus === "pending",
        isSuccess: fetchStatus === "success",
        isError: fetchStatus === "error",
    };
});
//# sourceMappingURL=selectAddressesFetchState.js.map